import { useConnectionStore } from '@/stores/connectionStore';
import { useRouter } from 'vue-router';
import axios from "axios";

const contaboWebsiteURL = "https://www.chessvis.com/"
const developmentWebsiteURL = "http://chessvis.ddns.net:8888/"
//const websiteURL = "http://192.168.1.11/"

// https://stackoverflow.com/questions/38241480/detect-macos-ios-windows-android-and-linux-os-with-js

export const getOS = (returnIndex) => {
  var userAgent = window.navigator.userAgent,
      platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;
  var index = "4"

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
    index = "9"
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
    index = "10"
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
    index = "11"
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
    index = "12"
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
    index = "13"
  }

  if (returnIndex)
    return (index)

  return os;
}

export function getWebSiteURL() {
  const websiteURL = (process.env.NODE_ENV === 'production') ? contaboWebsiteURL : developmentWebsiteURL
  return (websiteURL)
}

export function useGetData(programName, fieldData, processJsonResponse) {

  const websiteURL = (process.env.NODE_ENV === 'production') ? contaboWebsiteURL : developmentWebsiteURL

  //console.log("website  ",websiteURL)

  const URL = websiteURL + programName

  // convert the POST data from the calling program into a JSON object.
  // then add the "builtins" - cookie, dummy, calltype and platform (cook = 4) which is the "web"

  var postData = JSON.parse(JSON.stringify(fieldData))

  const connectionStore = useConnectionStore()
  const userdata = connectionStore.getStoredUserData
  const isEyeGaze = connectionStore.getIsEyeGaze
  const cookie = userdata.cookie
  const dummy = userdata.dummy

  postData.cookie = cookie
  postData.dummyUser = dummy
  postData.calltype = "2"
  postData.cook = (isEyeGaze) ? "8" : getOS(true)          // 4=new web, 8=eye gaze

  //console.log("**** postdata ",postData)
  var optionAxios = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
  axios.post(URL,postData,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log(response)

        //console.log("**** after response data.  cookie ",cookie)

        // check the cookie before going back to the calling routine
        if (cookie == "") {
          //console.log("in new cookie")
          const jsonCookie = response.data.hasOwnProperty("cookie") ? response.data['cookie'] : null
          const jsonDummy = response.data.hasOwnProperty("dummy") ? response.data['dummy'] : null
          //console.log("before if", jsonCookie, jsonDummy)
          if (jsonCookie != null && jsonDummy != null) {
            connectionStore.updateStoredUserCookieDummy(jsonCookie,jsonDummy)            
          }
        }
        //console.log("In Getdata good data")
        processJsonResponse(response.data);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : programName}
      console.log("In Getdata error -> ",errorJson)
      processJsonResponse(errorJson);
    })
}

// special getdata for use by startup because it will have a callback into the initiating routine
export function useGetDataStartup(programName, fieldData, processJsonResponse,afterProcessingCallbackRoutine) {

  const websiteURL = (process.env.NODE_ENV === 'production') ? contaboWebsiteURL : developmentWebsiteURL

  //console.log("website  ",websiteURL)

  const URL = websiteURL + programName

  // convert the POST data from the calling program into a JSON object.
  // then add the "builtins" - cookie, dummy, calltype and platform (cook = 4) which is the "web"

  var postData = JSON.parse(JSON.stringify(fieldData))

  const connectionStore = useConnectionStore()
  const userdata = connectionStore.getStoredUserData
  const isEyeGaze = connectionStore.getIsEyeGaze
  const cookie = userdata.cookie
  const dummy = userdata.dummy

  postData.cookie = cookie
  postData.dummyUser = dummy
  postData.calltype = "2"
  postData.cook = (isEyeGaze) ? "8" : getOS(true)           // 4=new web, 8=eye gaze

  //console.log("**** postdata ",postData)
  var optionAxios = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
  axios.post(URL,postData,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log(response)

        //console.log("**** after response data.  cookie ",cookie)

        // check the cookie before going back to the calling routine
        if (cookie == "") {
          //console.log("in new cookie")
          const jsonCookie = response.data.hasOwnProperty("cookie") ? response.data['cookie'] : null
          const jsonDummy = response.data.hasOwnProperty("dummy") ? response.data['dummy'] : null
          //console.log("before if", jsonCookie, jsonDummy)
          if (jsonCookie != null && jsonDummy != null) {
            connectionStore.updateStoredUserCookieDummy(jsonCookie,jsonDummy)            
          }
        }
        //console.log("In Getdata for startup routine")
        processJsonResponse(response.data,afterProcessingCallbackRoutine);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : programName}
      //console.log("In Getdata error -> ",errorJson)
      processJsonResponse(errorJson,afterProcessingCallbackRoutine);
    })
}

// https://stackoverflow.com/questions/5684303/javascript-window-open-pass-values-using-post

export function useGetDataDownload(programName, fieldData) {

  const websiteURL = (process.env.NODE_ENV === 'production') ? contaboWebsiteURL : developmentWebsiteURL

  //console.log("website  ",websiteURL)

  const URL = websiteURL + programName
  //window.open(URL)

  // convert the POST data from the calling program into a JSON object.
  // then add the "builtins" - cookie, dummy, calltype and platform (cook = 4) which is the "web"

  var postData = JSON.parse(JSON.stringify(fieldData))

  const connectionStore = useConnectionStore()
  const userdata = connectionStore.getStoredUserData
  const isEyeGaze = connectionStore.getIsEyeGaze
  const cookie = userdata.cookie
  const dummy = userdata.dummy

  postData.cookie = cookie
  postData.dummyUser = dummy
  postData.calltype = "2"
  postData.cook = (isEyeGaze) ? "8" : getOS(true)           // 4=new web, 8=eye gaze

  var form = document.createElement("form");
  form.target = "_blank";
  form.method = "POST";
  form.action = URL;
  form.style.display = "none";

  for (var key in postData) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = postData[key];
      form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

}

// set fieldData to null for a "get" call

export function getLichessData(lichessURL, accessToken,fieldData, processJsonResponse) {

  // set accessToken to "pgn" when downloading games

  //const accessToken1 = "lip_J07IAf4R0NUi2viunntt"

  //console.log("**** access token",accessToken)

  var optionAxios = {
    headers: {
        'Accept' : (accessToken == "pgn") ? 'x-chess-pgn' : 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
    }
  }

  // some calls like to see if the token is valid don't need a Bearer Token
  
  if (accessToken != null && accessToken != "pgn")
    optionAxios.headers.Authorization = "Bearer " + accessToken

  // if fieldData is set to null then do a "GET"

  if (fieldData == null) {
    //console.log("######## GET call")
    axios.get(lichessURL,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log("JSON back from Lichess",response)
        processJsonResponse(response.data);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : lichessURL}
      //console.log("In getLichess error -> ",errorJson)
      processJsonResponse(errorJson);
    })
  }
  else {
    // convert the POST data from the calling program into a JSON object.
    var postData = JSON.parse(JSON.stringify(fieldData))

    //console.log("**** postdata ",postData)

    axios.post(lichessURL,postData,optionAxios)
      .then(
        response => {

          // this shows the JSON coming back from the server
          //console.log("JSON back from Lichess",response)
          processJsonResponse(response.data);
        }
      )
      .catch(error => {
        const errorJson = { "error" : error , "programRun" : lichessURL}
        //console.log("In getLichess error -> ",errorJson)
        processJsonResponse(errorJson);
      })
  }
}

// set fieldData to null for a "get" call

export function getChesscomData(chesscomURL,fieldData, processJsonResponse) {

  var optionAxios = {
    headers: {
        'User-Agent': 'Chessvis henry@chessvis.com'
    }
  }

  // if fieldData is set to null then do a "GET"

  if (fieldData == null) {
    //console.log("######## GET call")
    axios.get(chesscomURL,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log("JSON back from Lichess",response)
        processJsonResponse(response.data);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : chesscomURL}
      //console.log("In chesscom get error -> ",errorJson)
      processJsonResponse(errorJson);
    })
  }
  else {
    // convert the POST data from the calling program into a JSON object.
    var postData = JSON.parse(JSON.stringify(fieldData))

    //console.log("**** postdata ",postData)

    axios.post(chesscomURL,postData,optionAxios)
      .then(
        response => {

          // this shows the JSON coming back from the server
          //console.log("JSON back from chesscom",response)
          processJsonResponse(response.data);
        }
      )
      .catch(error => {
        const errorJson = { "error" : error , "programRun" : chesscomURL}
        //console.log("In getChesscom error -> ",errorJson)
        processJsonResponse(errorJson);
      })
  }
}

export function generateErrorAlertText(json) {
  const text = "ERROR while running -> " + json['programRun'] + "\n\n" + json['error']
                  + "\n\n" + "*** PLEASE send this message to henry@chessvis.com"
  return (text)
}
